import { Injectable } from '@angular/core';
import { Observable, of, throwError, firstValueFrom } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators'; import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class CartNuvemShopService {
  constructor(private http: HttpClient) { }

  /**
   * Adiciona 1 item no carrinho REAL da Nuvemshop (storefront).
   * Só funciona se o código estiver rodando NO domínio da loja.
   */
  // addToCartStorefront(payload: {
  //   product_id: number;
  //   variant_id: number;
  //   quantity: number;
  //   zipcode?: string;
  // }): Observable<any> {

  //   const body = new HttpParams()
  //     .set('add_to_cart', String(payload.product_id))
  //     .set('add_to_cart_enhanced', '1')
  //     .set('variant_id', String(payload.variant_id))
  //     .set('quantity', String(payload.quantity))
  //     .set('zipcode', payload.zipcode ?? '');

  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
  //     'X-Requested-With': 'XMLHttpRequest',
  //     'Accept': 'application/json, text/javascript, */*; q=0.01',
  //   });

  //   return this.http.post<any>('/comprar/', body.toString(), {
  //     headers,
  //     withCredentials: true,
  //     observe: 'response',
  //   }).pipe(
  //     tap(resp => this.persistArtifactsFromBody(resp?.body))
  //   );
  // }
  addToCartStorefront(payload: {
    product_id: number;
    variant_id?: number | string;
    quantity: number;
    zipcode?: string;
    variations?: string[]; // ✅ novo
  }): Observable<any> {

    const p = Number(payload.product_id || 0);
    const v = Number(String(payload.variant_id ?? '').match(/(\d+)$/)?.[1] || 0);
    const variations = (payload.variations || []).filter(Boolean).map(String);

    if (!p) throw new Error('Nuvemshop: faltou product_id.');

    let body = new HttpParams()
      .set('add_to_cart', String(p))
      .set('add_to_cart_enhanced', '1')
      .set('quantity', String(payload.quantity))
      .set('zipcode', payload.zipcode ?? '');

    // ✅ só manda variant_id se tiver
    if (v) {
      body = body.set('variant_id', String(v));
    }

    // ✅ manda variation[0], variation[1], ...
    variations.forEach((val, idx) => {
      body = body.set(`variation[${idx}]`, val);
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/json, text/javascript, */*; q=0.01',
    });

    console.log('body')
    console.log(body)


    return this.http.post<any>('/comprar/', body.toString(), {
      headers,
      withCredentials: true,
      observe: 'response',
    }).pipe(
      tap(resp => this.persistArtifactsFromBody(resp?.body))
    );
  }

  // addToCartStorefront(payload: {
  //   product_id: number;
  //   variant_id?: number | string;
  //   quantity: number;
  //   zipcode?: string;
  // }): Observable<any> {

  //   const p = Number(payload.product_id || 0);
  //   const v = Number(String(payload.variant_id ?? '').match(/(\d+)$/)?.[1] || 0);

  //   if (!p) {
  //     throw new Error('Nuvemshop: faltou product_id.');
  //   }

  //   console.log('produto ', p)
  //   console.log('variante ', v)
  //   console.log('payload ', payload)

  //   const body = new HttpParams()
  //     .set('add_to_cart', String(p))                 // ✅ produto
  //     .set('add_to_cart_enhanced', '1')
  //     .set('variant_id', String(v || ''))            // ✅ variante separada (quando houver)
  //     .set('quantity', String(payload.quantity))
  //     .set('zipcode', payload.zipcode ?? '');

  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
  //     'X-Requested-With': 'XMLHttpRequest',
  //     'Accept': 'application/json, text/javascript, */*; q=0.01',
  //   });

  //   return this.http.post<any>('/comprar/', body.toString(), {
  //     headers,
  //     withCredentials: true,
  //     observe: 'response',
  //   }).pipe(
  //     tap(resp => this.persistArtifactsFromBody(resp?.body))
  //   );
  // }



  createCheckoutUrl(
    storeId: number,
    items: Array<{ variant_id: number; quantity: number }>,
  ): Observable<{ checkout_url?: string; abandoned_checkout_url?: string }> {

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/public/admin/store/${storeId}/nuvemshop/checkout-url`;

    const headers = new HttpHeaders({
      'X-Full-Referer': window.location.href,
    });

    return this.http.post<{ checkout_url?: string; abandoned_checkout_url?: string }>(
      url,
      { items },
      { headers, withCredentials: false }
    );
  }



  /**
 * Atualiza a quantidade do item no carrinho REAL (storefront).
 * Endpoint observado: POST /cart/update/
 * Body: quantity[ITEM_ID]=QTY
 */
  updateQuantityStorefront(lineItemId: number, quantity: number): Observable<HttpResponse<any>> {
    const body = new HttpParams().set(`quantity[${lineItemId}]`, String(quantity));

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/json, text/javascript, */*; q=0.01',
    });

    return this.http.post<any>('/cart/update/', body.toString(), {
      headers,
      withCredentials: true,
      observe: 'response',
    }).pipe(
      tap(resp => this.persistArtifactsFromBody(resp?.body))
    );
  }

  removeItemStorefront(lineItemId: number): Observable<HttpResponse<any>> {
    return this.updateQuantityStorefront(lineItemId, 0);
  }



  persistArtifactsFromBody(body: any) {
    const cart = body?.cart;
    if (!cart) return;

    if (cart?.id) localStorage.setItem('ss_nuvemshop_cart_id', String(cart.id));

    const token = cart?.token;
    const abandonedUrl = cart?.abandoned_checkout_url;

    if (token) localStorage.setItem('ss_nuvemshop_cart_token', String(token));
    if (abandonedUrl) localStorage.setItem('ss_nuvemshop_abandoned_checkout_url', String(abandonedUrl));

    // ✅ merge do map existente
    const existingRaw = localStorage.getItem('ss_nuvemshop_line_item_map');
    const existing = existingRaw ? JSON.parse(existingRaw) : {};

    const next: Record<string, number> = { ...existing };

    (cart?.products || []).forEach((p: any) => {
      if (p?.variant_id && p?.id) {
        next[String(p.variant_id)] = Number(p.id);
      }
    });

    if (Object.keys(next).length) {
      localStorage.setItem('ss_nuvemshop_line_item_map', JSON.stringify(next));
    }
  }




  // redirectToCheckout(): void {
  //   const checkoutUrl = localStorage.getItem('ss_nuvemshop_abandoned_checkout_url');

  //   if (checkoutUrl) {
  //     window.location.href = checkoutUrl;
  //     return;
  //   }

  //   // fallback seguro dentro da loja
  //   window.location.href = '/checkout';
  // }

  private headers = new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'X-Requested-With': 'XMLHttpRequest',
    'Accept': 'application/json, text/javascript, */*; q=0.01',
  });

  private isInsideStorefront(): boolean {
    const LS = (window as any).LS;
    return !!(LS?.store);
  }

  private getLocalCart(): any[] {
    try {
      const raw = localStorage.getItem('ss_shopping_cart');
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  private getLineItemMap(): Record<string, number> {
    try {
      const raw = localStorage.getItem('ss_nuvemshop_line_item_map');
      return raw ? JSON.parse(raw) : {};
    } catch {
      return {};
    }
  }

  /** ✅ tenta usar o cached; senão, força /cart/update/ pra Nuvemshop devolver abandoned_checkout_url */
  getOrCreateCheckoutUrl(): Observable<string> {
    const cached = localStorage.getItem('ss_nuvemshop_abandoned_checkout_url');
    if (cached) return of(cached);

    if (!this.isInsideStorefront()) {
      // fora do domínio da loja não dá pra chamar /cart/update
      return of('/checkout');
    }

    const items = this.getLocalCart();
    const mapVariantToLine = this.getLineItemMap();

    // monta o body quantity[LINE_ID]=QTY quando possível
    let params = new HttpParams();
    let hasAtLeastOne = false;

    for (const it of items) {
      const variantId = Number(it.variant_id || it.id);
      const qty = Number(it.quantity || 1);
      const lineId = Number(mapVariantToLine[String(variantId)]);

      if (lineId) {
        params = params.set(`quantity[${lineId}]`, String(qty));
        hasAtLeastOne = true;
      }
    }

    // ✅ mesmo se não tiver map ainda, manda update vazio só pra obter o cart + abandoned url
    const bodyString = hasAtLeastOne ? params.toString() : '';

    return this.http
      .post<any>('/cart/update/', bodyString, {
        headers: this.headers,
        withCredentials: true,
        observe: 'response',
      })
      .pipe(
        map((resp: HttpResponse<any>) => resp.body),
        tap((body) => this.persistArtifactsFromBody(body)),
        map((body) => body?.cart?.abandoned_checkout_url || '/comprar'),
        catchError(() => of('/comprar'))
      );
  }

  /** versão “final”: resolve URL e redireciona */
  redirectToCheckout(): void {
    this.getOrCreateCheckoutUrl().subscribe((url) => {
      console.log('url do checkout ')
      console.log(url)
      window.location.href = url;
    });
  }


  // CartNuvemShopService
  humanizeNuvemshopError(
    input: any,
    fallback = 'Ocorreu um erro ao atualizar o carrinho.'
  ): string {
    // input pode ser: body JSON, string HTML, HttpErrorResponse, etc.
    const raw =
      input?.error?.error_code ??
      input?.error?.code ??
      input?.error?.message ??
      input?.error?.error ??
      input?.error_code ??
      input?.code ??
      input?.message ??
      input?.error ??
      input;

    const text = String(raw ?? '').toLowerCase();

    // padrões comuns
    if (text.includes('out_of_stock') || text.includes('stock')) {
      return 'Produto sem estoque no momento.';
    }

    if (text.includes('not_available') || text.includes('unavailable')) {
      return 'Produto indisponível no momento.';
    }

    if (text.includes('invalid_variant')) {
      return 'Variação inválida para este produto.';
    }

    // se vier só "out_of_stock" puro
    if (text && /^[a-z0-9_]+$/.test(text)) {
      return 'Não foi possível concluir a ação no carrinho.';
    }

    // se for HTML e tiver uma pista
    if (text.includes('<html') || text.includes('<!doctype')) {
      // não tenta ver texto inteiro (vai ficar feio)
      return fallback;
    }

    // se tiver mensagem “humana”
    if (typeof raw === 'string' && raw.trim()) return raw.trim();

    return fallback;
  }


  refreshCartArtifactsStorefront(): Observable<void> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/json, text/javascript, */*; q=0.01',
    });

    return this.http.post<any>('/cart/update/', '', {
      headers,
      withCredentials: true,
      observe: 'response',
    }).pipe(
      tap(resp => this.persistArtifactsFromBody(resp?.body)),
      // só pra tipar bonitinho
      map(() => void 0)
    );
  }


}
